import { isString } from 'lodash';
import { useState } from 'react';
import './App.css';
function App() {
  const dateTextFormTotalText = (totalSeconds: number | string) => {
    let _totalSeconds = totalSeconds
    if (isString(totalSeconds)) {
      _totalSeconds = parseInt(totalSeconds)
    }
    const date = new Date(_totalSeconds)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    // const dayOfWeek = date.getDay()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const seconds = date.getSeconds()
    // const timeZoneOffset = date.getTimezoneOffset()
    const dateText = year+'/'+month+'/'+day + ' ' + hour + ':' + minute+':'+seconds
    return dateText
  }

   const [num, setNum] = useState('')
  const onChangeTotalSeconds = (e:any) => {
    setNum(dateTextFormTotalText(e.target.value))
  }
  //TODO:配列対応。useRefでのやり方。スタイル適用。
  return (
    <div className="App">
      <h1>日付のTotalSecondsを入力すると、文字列で表示します</h1>
      <div style={{margin: '150px'}}>
      <input onChange={onChangeTotalSeconds} type="number" />
      <div style={{margin: '50px'}}>{num}</div>
      </div>
    </div>
  );
}

export default App;
